import React from 'react';
import MinorMemberList from '../components/MinorMembers/MinorMemberList';

const MinorMembers = () => <MinorMemberList />;

export default MinorMembers;
